import './new-shift-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateShiftType } from "@core/query/shift-type.query";
import { ShiftTypeFormRule, ShiftTypeFormSchema } from "@core/form/form.rule";
import { shiftTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormShiftType from "../form-shift-type/form-shift-type";

export function ShiftType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateShiftType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New ShiftType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addShiftType, isLoading: isCreating } =
    useQyCreateShiftType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ShiftTypeFormSchema>({
    defaultValues: shiftTypeFormDefault,
    resolver: zodResolver(ShiftTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ShiftTypeFormSchema) => {
    const formData = mapCreateShiftType(form);
    addShiftType(formData);
  };
  const handleValidateError = (err: FieldErrors<ShiftTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="ShiftType" className="shift-type">
      <HeaderContent
        title="New ShiftType"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormShiftType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default ShiftType;